// ./src/utils/api/vendorHistoryVocabulary.ts
//
// ROADMAP #202 — the server's words for a line of a request's history (`src/boundary/vendorCompliance.ts`; the API's
// `check-vendor-compliance` compares them). Apart from the service so `check-vendor-history` can load it without a browser build.

/** What a line says happened. */
export const VENDOR_HISTORY_KIND = {
  APPROVED: "approved",
  RETURNED: "returned",
  DOCUMENT_RECEIVED: "document_received",
  DOCUMENT_REMOVED: "document_removed",
  TYPE_CHANGED: "type_changed",
  CHECKS_CHANGED: "checks_changed",
  KIND_CHANGED: "kind_changed",
  DOCUMENT_CHANGED: "document_changed",
  REQUEST_REMOVED: "request_removed",
} as const;

/** Who did it. */
export const VENDOR_HISTORY_ACTOR = {
  CREW: "crew",
  VENUE: "venue",
  VENDOR: "vendor",
  UNKNOWN: "unknown",
} as const;
